import {
  ButtonWithIcon,
  CaretCircleDownIcon,
  CaretCircleUpIcon,
  EnvelopeIcon,
  FacebookLogoIcon,
  HideFor,
  LinkShare,
  LinkedinLogoIcon,
  PrinterIcon,
  XCloseIcon,
  XTwitterIcon,
} from "/App.Components";
import { PrintAndShareProps } from "/Models/Generated/PrintAndShareProps";
import "./PrintAndShare.scss";
import { useRef, useState } from "react";
import useClickOutsideElement from "/Helpers/Hooks/useClickOutsideElement";
import useEscapeElement from "/Helpers/Hooks/useEscapeElement";
import { ColorTheme } from "/Models/Models/ColorTheme";

const printAndShare = ({
  printLabel,
  hideShareButton,
  shareLabel,
  facebookLink,
  linkedInLink,
  xTwitterLink,
  emailLink,
  hidePrintButton,
  dropdownId,
}: PrintAndShareProps) => {
  const [shareDropdown, setShareDropdown] = useState(false);
  const openDropdown = useRef<HTMLDivElement | null>(null);
  const dropdownButton = useRef<HTMLDivElement | null>(null);
  useClickOutsideElement(
    () => setShareDropdown(false),
    [openDropdown, dropdownButton]
  );

  useEscapeElement(shareDropdown, () => setShareDropdown(false), openDropdown);

  const ShareIcon = shareDropdown ? CaretCircleUpIcon : CaretCircleDownIcon;

  if (hidePrintButton && hideShareButton) return null;

  return (
    <div className="print-and-share-norad">
      {!hideShareButton && (
        <div className="print-and-share-norad__dropdown">
          <div ref={dropdownButton} data-testid="print_and_share_btn_container">
            <ButtonWithIcon
              ariaExpanded={shareDropdown}
              ariaControls={dropdownId}
              icon={ShareIcon}
              iconPlacement={"after"}
              onClickHandler={() => setShareDropdown((prev) => !prev)}
              text={shareLabel}
              style="thin"
              colorTheme={ColorTheme.default}
            />
          </div>
          <div
            id={dropdownId}
            className={`print-and-share-norad__dropdown-content print-and-share-norad__dropdown-content${
              shareDropdown ? "--open" : ""
            }`}
            ref={openDropdown}
          >
            {/* Please check the icons. The Twitter icon is wrong. */}
            <LinkShare {...facebookLink} isExternal icon={FacebookLogoIcon} />
            <LinkShare {...linkedInLink} isExternal icon={LinkedinLogoIcon} />
            <LinkShare
              {...xTwitterLink}
              isExternal
              icon={XCloseIcon}
              iconMobile={XTwitterIcon}
            />
            <LinkShare {...emailLink} isExternal icon={EnvelopeIcon} />
          </div>
        </div>
      )}
      {!hidePrintButton && (
        <div>
          <HideFor mobile tablet>
            <ButtonWithIcon
              icon={PrinterIcon}
              iconPlacement={"after"}
              text={printLabel}
              onClickHandler={() => window.print()}
              style="thin"
            />
          </HideFor>
          <HideFor desktop desktopMedium desktopLargeUp>
            <ButtonWithIcon
              icon={PrinterIcon}
              iconPlacement={"after"}
              text={printLabel}
              onClickHandler={() => window.print()}
              style="thin"
            />
          </HideFor>
        </div>
      )}
    </div>
  );
};
export default printAndShare;
